import styled from 'styled-components'

import ModalDialog from 'v2/components/UI/ModalDialog'

export default styled(ModalDialog).attrs({
  maxWidth: '55em',
})``
